import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'boostCategory'
})
export class BoostCategoryPipe implements PipeTransform {

    transform(value: any, ...args: any[]): any {
        switch (value) {
            case 'aplus':
                return 'A+'
            case 'a':
            case 'b':
                return value.toUpperCase()
        }
        return 'NoCategory';
    }

}
